import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import * as contactSelectors from "@rentiohq/shared-frontend/dist/redux/contact/contact.selectors";
import { IRootStore } from "redux/reducers";
import { EField } from "./schema.linkContact.types";

export const isPerformingSubmitActionSelector = (state: IRootStore) =>
  contactSelectors.isLinkingContact(state);

export const performingSubmitActionErrorSelector = (state: IRootStore) =>
  contactSelectors.linkContactError(state);

export const submitActionCreator = (formData: any, contactId: number) => {
  const existingAccountId = formData[EField.Contact]?.[0];
  return contactActions.linkContact.actions.start({
    contactId,
    existingAccountId,
  });
};
